module.exports = __webpack_public_path__ + "static/media/TN-Women-Skirts-2.0.80bb8ed9.svg";